import includes from 'lodash/includes';
import React from 'react';
import PropTypes from 'prop-types';
import {Link as ReactRouterLink} from 'react-router-dom';

const Link = ({className, forceAnchor, to, children, onClick, ...props}) => {
    if (forceAnchor || includes(to, 'http')) {
        return (
            <a className={className} href={to} onClick={onClick} {...props}>
                {children}
            </a>
        );
    } else {
        return (
            <ReactRouterLink
                className={className}
                to={to}
                onClick={onClick}
                {...props}
            >
                {children}
            </ReactRouterLink>
        );
    }
};

Link.propTypes = {
    className: PropTypes.string,
    forceAnchor: PropTypes.bool,
    to: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default Link;
